import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/TermsConditions.css'; 

const TermsConditions = () => {
  return (
    <div>

      {/* Banner Section */}
      <div className="inner-pages-bnr">
        <img src="images/service-banner.jpg" className="img-responsive" alt="contact-banner-image" />
        <div className="banner-caption">
          <h1>Terms & Conditions</h1>
          <ul className="breadcumb">
            <li><a href="#">Home</a> - </li>
            <li>Terms & Conditions</li>
          </ul>
        </div>
      </div>

      <section className="terms-section">
        <div className="container">
          <div className="row g-0">
            {/* Text Content Column */}
            <div className="col-md-7">
              <div className="terms-content">
                <p><b className="highlight">1. Booking Confirmation:</b> All bookings with Anjali Enterprises are confirmed upon successful payment and issuance of a booking reference number.</p>

                <p><b className="highlight">2. Payment:</b> Full payment is required at the time of booking. Payments can be made through our website or at our authorized offices.</p>

                <p><b className="highlight">3. Cancellation and Rescheduling:</b> Cancellations and rescheduling requests are subject to our cancellation policy. Fees may apply based on the timing of the request.</p>

                <p><b className="highlight">4. Customer Responsibility:</b> Customers must carry valid identification and booking confirmation. We reserve the right to refuse service without proper documentation.</p>

                <p><b className="highlight">5. Service Scope:</b> The services provided by Anjali Enterprises include all types of aluminium glass partitions, toughened glass work, ACP cladding, industrial and home renovation work, and various fabrication services.</p>

                <p><b className="highlight">6. Quality Assurance:</b> We ensure that all materials and workmanship meet industry standards. Any discrepancies or issues should be reported immediately to ensure timely resolution.</p>

                <p><b className="highlight">7. Safety Regulations:</b> Customers must adhere to all safety guidelines during installation and service procedures, and follow instructions from our team.</p>

                <p><b className="highlight">8. Changes to Service Offerings:</b> Anjali Enterprises reserves the right to modify, update, or discontinue services due to unforeseen circumstances beyond our control.</p>

                <p><b className="highlight">9. Refusal of Service:</b> We may refuse service to customers who exhibit disruptive behavior or fail to adhere to the terms and conditions outlined in this policy.</p>

                <p><b className="highlight">10. Jurisdiction:</b> These terms are governed by the laws of India. Any disputes will be resolved in the jurisdiction of Mumbai.</p>

                <h3>General Policy</h3>
                <p><b className="highlight">Booking Procedure:</b> Customers can book services through our website or by contacting our customer service team directly.</p>
                <p><b className="highlight">Customer Support:</b> Our support team is available to assist with any inquiries or requests regarding bookings and services.</p>

                <h3>Refund Policy</h3>
                <p><b className="highlight">• </b>If you cancel a service request, cancellation charges will apply as per the terms mentioned in the cancellation policy of Anjali Enterprises.</p>
                <p><b className="highlight">• </b>If eligible for a refund based on the “Cancellation & Refund Policy,” the refund will be processed within 5-7 working days.</p>
              </div>
            </div>

          </div>

          <div className="contact-info">
            <h2>Contact Us</h2>
            <p>If you have any questions regarding our terms, feel free to reach out:</p>
            <ul>
              <li><b>Phone:</b> <a href="tel:+918793220265">+91 8793220265</a></li>
              <li><b>Email:</b> <a href="mailto:info@anjalienterprisesindia.com">info@anjalienterprisesindia.com</a></li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;
